import {
  Box,
  Flex,
  useColorModeValue,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

const InnerTable = ({ data, onRowClick, rowRenderer }) => {

  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const bgColor = useColorModeValue('gray.50', 'gray.700');
  const boxBgColor = useColorModeValue('white', 'gray.600');

  const rows = Array.isArray(data) ? data : [];

  return (
    <Box 
      mt={2} 
      p={4}
      bg={bgColor} 
      borderRadius="md"
      cursor={!!onRowClick ? 'pointer' : 'default'}
    >
      {
        rows.map((row, rowIndex) => (
        <Box
          key={rowIndex}
          p={3}
          mb={2}
          bg={boxBgColor}
          borderRadius="md"
          border="1px solid"
          borderColor={borderColor}
          _last={{ mb: 0 }}
          onClick={onRowClick && (() => onRowClick(row))}
        >
          <Flex gap={4} justify="space-between">
            {rowRenderer(row).map((value, colIndex) => (
              <Box
                key={colIndex}
                fontSize="sm"
                fontWeight="medium"
                flex="1"
                textAlign="center"
              >
                {value}
              </Box>
            ))}
          </Flex>
        </Box>
      ))
      }
    </Box>
  );
};

InnerTable.propTypes = {
  data: PropTypes.array,
  onRowClick: PropTypes.func,
  rowRenderer: PropTypes.func,
};

export default InnerTable;